import { createContext, useContext, useEffect } from "react";
import { useObjectState } from "../hooks/useObjectState";
import { parseDates } from "../hooks/useApi";

const Context = createContext()

export function Storage({ children }) {
    const session = localStorage.getItem("app")
    const initialStorage = session ? parseDates(JSON.parse(session)) : {}
    const [storage, setStorage, set] = useObjectState(initialStorage)

    useEffect(() => {
        localStorage.setItem("app", JSON.stringify(storage))
    }, [storage])

    return <Context.Provider value={[storage, setStorage, set]}>
        {children}
    </Context.Provider>
}

export const useStorage = () => useContext(Context)